export const CHIP_COLOURS = {
  default: 'bg-gray-50 text-gray-600 border-gray-200',
  processing: 'border-sky-300 bg-sky-50 text-sky-600',
  type: 'bg-violet-50 text-violet-500 border-violet-200',
  issue: 'bg-blue-50 text-blue-500 border-blue-200',
  extension: 'bg-gray-100 text-gray-600 border-gray-200',
  hasRelevantFacts: 'bg-green-50 border-green-200 text-green-600',
  levels: {
    critical: 'bg-red-50 border-red-200 text-red-600',
    severe: 'bg-amber-50 border-amber-200 text-amber-600',
    minor: 'bg-sky-50 border-sky-200 text-sky-600',
  },
  relevance: {
    relevant: 'bg-green-50 text-green-600 border-green-300',
    maybeRelevant: 'bg-amber-50 border-amber-200 text-amber-600',
    notRelevant: 'bg-gray-100 text-gray-500 border-gray-300',
  },
  key: 'bg-amber-50 text-amber-600 border-amber-300',
  inconsistencySource: 'bg-gray-100 text-gray-600 border-gray-200',
  inconsistencyType: 'bg-cyan-50 text-cyan-600 border-cyan-200',
  disputed: 'bg-red-50 text-red-500 border-red-300',
  subset: 'bg-gray-100 border-gray-300 text-gray-700',
  verified: 'bg-green-50 text-green-600 border-green-300',
  relativity: 'bg-purple-50 text-purple-500 border-purple-300',
};
